/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Alert, Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICookieComplianceViewProps } from '@msdyn365-commerce-modules/cookie-compliance/src/modules/cookie-compliance/./cookie-compliance';
import { ICookieComplianceProps as ICookieComplianceExtensionProps } from './../definition-extensions/cookie-compliance.ext.props.autogenerated';
declare global {
    interface Window {
        CookieConsent: {
            consent: {
                necessary: boolean;
            };
        };
    }
}
const CookieComplianceView: React.FC<ICookieComplianceViewProps & ICookieComplianceExtensionProps<{}>> = props => {
    const { CookieComplianceBanner, AlertProps, Content, acceptButton, text, links, config, context } = props;
    const { externalConsent } = config;

    React.useEffect(() => {
        if (externalConsent) {
            const consentChoosed = () => {
                if (context && context.request && context.request.cookies) {
                    context.request.cookies.setConsentCookie();
                    location.reload();
                }
            };
            if (window.CookieConsent.consent.necessary) {
                context.request.cookies.setConsentCookie();
                location.reload();
            }
            window.addEventListener(
                'CookiebotOnAccept',
                () => {
                    window.CookieConsent.consent.necessary && consentChoosed();
                },
                false
            );
        }
    }, []);

    return (
        <>
            {!externalConsent && (
                <Module {...CookieComplianceBanner}>
                    <Alert className={AlertProps.className} color={AlertProps.color} fade={AlertProps.fade}>
                        <Node {...Content}>
                            {text}
                            {links}
                        </Node>
                        {acceptButton}
                    </Alert>
                </Module>
            )}
        </>
    );
};
export default CookieComplianceView;
